import Footer from "../Footer/Footer";
import Header from "../Header/Header";

import BlockContent from "../Block/BlockContent";
import BlockTitle from "../Block/BlockTitle";
import BlockSubtitle from "../Block/BlockSubtitle";
import BlockText from "../Block/BlockText";
import Block from "../Block/Block";

import conferenceData from './conferences.json'; // Pfad zur JSON-Datei anpassen
import workshopData from './workshops.json'; // Pfad zur JSON-Datei anpassen
import journalsData from './journals.json'; // Pfad zur JSON-Datei anpassen



function RemainingDays(dateStr) {
    // Ziel-Datum im Format TT.MM.JJJJ
    const targetDateStr = dateStr;
    // Umwandlung des Ziel-Datums in ein Date-Objekt
    const [day, month, year] = targetDateStr.split(".");
    const targetDate = new Date(`${year}-${month}-${day}`);
    // Berechnung der verbleibenden Tage
    const today = new Date();
    const difference = targetDate - today;
    const remainingDays = Math.ceil(difference / (1000 * 60 * 60 * 24)) || 0;
  
    // Bestimmung der Textfarbe basierend auf dem Wert von remainingDays
    const textColor = remainingDays <= 0 ? "red" : "green";
  
    return (
      <span style={{color: textColor}}>
        {remainingDays}
      </span>
    );
}

function RemainingDaysInt(dateStr) {
    // Ziel-Datum im Format TT.MM.JJJJ
    const targetDateStr = dateStr;
    // Umwandlung des Ziel-Datums in ein Date-Objekt
    const [day, month, year] = targetDateStr.split(".");
    const targetDate = new Date(`${year}-${month}-${day}`);
    // Berechnung der verbleibenden Tage
    const today = new Date();
    const difference = targetDate - today;
    const remainingDays = Math.ceil(difference / (1000 * 60 * 60 * 24)) || 0;
    // Behandeln Sie den Fall, dass daysLeft NaN ist, mit 0
    return isNaN(remainingDays) ? 0 : remainingDays;
}

function ConferenceList(data) {
    const sortedConferences = data.sort((a, b) => RemainingDaysInt(b.deadline) - RemainingDaysInt(a.deadline));
    return (
      <div>
        {
            sortedConferences.map((conference, index) => (
                <div key={index}>
                    <BlockText>
                        <b>{conference.name}</b> ({conference.description})
                        <ul>
                            <li>Impact Score: {conference.impactScore}</li>
                            <li>Deadline: {conference.deadline}</li>
                            <li>Days Left: {RemainingDays(conference.deadline)}</li>
                            <li>Location: {conference.place}</li>
                            <li>Web: <a href={conference.web} target="_blank" rel="noopener noreferrer">{conference.web}</a></li>
                            <li>Notes: {conference.notes}</li>
                        </ul>
                    </BlockText>
                    <hr/>
                </div>
            ))
        }
      </div>
    );
}

function JounralsList(data) {
    const sortedConferences = data.sort((a, b) => b.impactScore - a.impactScore);
    return (
      <div>
        {
            sortedConferences.map((conference, index) => (
                <div key={index}>
                    <BlockText>
                        <b>{conference.name}</b> ({conference.description})
                        <ul>
                            <li>Impact Score: {conference.impactScore}</li>
                            <li>Web: <a href={conference.web} target="_blank" rel="noopener noreferrer">{conference.web}</a></li>
                            <li>Notes: {conference.notes}</li>
                        </ul>
                    </BlockText>
                    <hr/>
                </div>
            ))
        }
      </div>
    );
}


function Publications() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="1200px">
        <BlockContent width="100%">
          <BlockTitle>List of Conferences, Journals and Workshops in the field of Computer Vision, Computer Graphics, XR and AI</BlockTitle>
          <BlockSubtitle>This blog entry provides details about upcoming and recently concluded events, including important dates such as paper submission deadlines and event dates. The focus is on topics in the fields of Computer Vision, Computer Graphics, XR and AI.</BlockSubtitle>
        </BlockContent>
      </Block>

      <Block colorTheme="dark" gridTemplateColumns="1200px">
        <BlockContent width="100%">
            <BlockSubtitle>Conferences</BlockSubtitle>
            {ConferenceList(conferenceData.conferences)}
        </BlockContent>
      </Block>

        <Block colorTheme="light" gridTemplateColumns="1200px">
        <BlockContent width="100%">
            <BlockSubtitle>Workshops</BlockSubtitle>
            {ConferenceList(workshopData.workshops)}
        </BlockContent>
        </Block>

      <Block colorTheme="dark" gridTemplateColumns="1200px">
        <BlockContent width="100%">
            <BlockSubtitle>Journals</BlockSubtitle>
            {JounralsList(journalsData.journals)}
        </BlockContent>
      </Block>

      <Footer/>
                 
    </div>
  );
}

export default Publications;
